module.exports = __webpack_public_path__ + "img/C05TechPrimusPilusChampion_ua.43a3930e.webp";